module.exports = __webpack_public_path__ + "static/media/16-aggressiv.d16c4b64.mp3";